import cloneDeep from 'lodash/cloneDeep';

/**
 * Mixes in a method to return just a plain object with no additional methods
 * @private
 * @param {Object} data - Any plain JSON response returned from the API
 * @return {Object} Enhanced object with toPlainObject method
 */
export default function toPlainObject(data) {
  return Object.defineProperty(data, 'toPlainObject', {
    enumerable: false,
    configurable: false,
    writable: false,
    value: function value() {
      return cloneDeep(this);
    }
  });
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/contentful-sdk-core/dist/es-modules/to-plain-object.js
// module id = 480
// module chunks = 0